import React from "react"
import styled from "styled-components"

const SectionSubTitleElement = styled.h3`
  text-transform: uppercase;
  text-align: center;
  font-weight: 400;
  margin-bottom: 50px;

  strong {
    font-weight: 700;
  }
  @media (${({ theme }): string => theme.screenSizes.sm}) {
    margin-bottom: 100px;
  }
`

type Props = {
  children: React.ReactNode
}

const SectionSubTitle: React.FC<Props> = ({ children, ...props }: Props) => {
  return <SectionSubTitleElement {...props}>{children}</SectionSubTitleElement>
}

export default SectionSubTitle
